import React, {FC, PropsWithChildren} from 'react';
import styled from 'styled-components';

import {fontSizes, fontWeights} from '../../../../../../../libs/shared/ui/src/styles/fontStyles';

/*
 * Props.
 */

interface MessageBannerTitleProps {
  color?: string;
  className?: string;
}

/*
 * Style.
 */

interface TitleStyleProps {
  $color?: string;
}

const StyledTitleDiv = styled.div<TitleStyleProps>`
  grid-area: title;
  font-size: ${fontSizes.verySmall};
  font-weight: ${fontWeights.bold};
  color: ${(p) => p.$color || p.theme.greys.white};
  min-width: 0;
  margin-left: 3px;
  margin-right: 3px;
`;

/*
 * Component.
 */

export const MessageBannerTitle: FC<PropsWithChildren<MessageBannerTitleProps>> = (props) => (
  <StyledTitleDiv $color={props.color} className={props.className}>
    {props.children}
  </StyledTitleDiv>
);
